const NAME = "STUDIES";

export default NAME;
